import { useLocation, useParams } from 'react-router-dom';
import InvoiceView from '../../../../features/InvoiceView/InvoiceView';
import LibModal from '../../../../features/LibModal/LibModal';
import NotFound from '../../../../features/NotFound/NotFoundPage';
import PageTitle from '../../../../utils/PageTitle';
import cn from '../../../../utils/cn';
import InvoiceInfoRightCol from './Components/InvoiceInfoRightCol';
import PageHeader from './Components/PageHeader';
import InvoiceInfoProvider, { useInvoiceInfo } from './InvoiceInfoProvider';
import PaymentReceiveModal from './Modals/PaymentReceiveModal';
import UpdateInvoiceNoteModal from './Modals/UpdateInvoiceNoteModal';

function PageContentBody({ myRef, invoiceInfo, handleReload, isReceipt }) {
    if (invoiceInfo && Object.keys(invoiceInfo).length === 0) {
        return (
            <div className="mt-10">
                <NotFound
                    title="Invoice Not Found!"
                    btnTitle="Reload"
                    evButtonClick={handleReload}
                    className="h-full"
                />
            </div>
        );
    }
    return (
        <div
            className={cn(
                `print:w-full flex flex-col xl:flex-row print:flex-none gap-5 justify-between items-stretch`,
                {
                    'placeholder-mode': invoiceInfo?.demo,
                    'justify-center': isReceipt
                }
            )}
        >
            <div
                className={cn(`w-full xl:w-[calc(100%_-_350px)] print:w-full`, {
                    'w-full': isReceipt
                })}
                id="printInvoicePage"
                ref={myRef}
            >
                <InvoiceView info={invoiceInfo} />
            </div>
            <div
                className={cn(
                    `w-full xl:w-[350px] print:w-0 print:hidden print:overflow-hidden h-full`,
                    {
                        'w-0 overflow-hidden hidden': isReceipt
                    }
                )}
            >
                <InvoiceInfoRightCol
                    invoiceData={invoiceInfo?.invoice}
                    billingAddress={invoiceInfo?.billingAddress}
                    invoiceItems={invoiceInfo?.invoiceItems}
                />
            </div>
        </div>
    );
}

function PageContent() {
    const { invoiceInfo, handleReload, modalType, closeModal } = useInvoiceInfo();

    const { state } = useLocation();

    const isReceipt = state?.title === 'Receipt';

    return (
        <div className="inner_page_cont flex print:flex-none justify-center mb-10 print:mb-0">
            <div className="w-[1170px] print:w-full">
                <PageHeader
                    handleReload={handleReload}
                    invoiceInfo={invoiceInfo}
                    isReceipt={isReceipt}
                />
                <PageContentBody
                    handleReload={handleReload}
                    invoiceInfo={invoiceInfo}
                    isReceipt={isReceipt}
                />
            </div>

            {/* modals */}
            {modalType === 'payment-receive' && (
                <LibModal title="Receive Payment" setOpen={closeModal}>
                    <PaymentReceiveModal
                        closeModal={closeModal}
                        invoiceData={invoiceInfo?.invoice}
                    />
                </LibModal>
            )}

            {modalType === 'update_invoice_note' && (
                <LibModal title="Update Invoice Note" setOpen={closeModal}>
                    <UpdateInvoiceNoteModal data={invoiceInfo?.invoice} closeModal={closeModal} />
                </LibModal>
            )}
        </div>
    );
}

function InvoiceInfoPage() {
    const { invoiceId } = useParams();

    // set page title
    PageTitle(`Invoice Details`);

    return (
        <InvoiceInfoProvider id={invoiceId}>
            <PageContent />
        </InvoiceInfoProvider>
    );
}

export default InvoiceInfoPage;
